// Thread selection model used by the workspace and sidebar when the host
// route has not supplied router-driven selection state yet.

import { useCallback, useState } from 'react';

export type ThreadSelection = {
  /** Currently selected thread id, or null when no thread is open. */
  threadId: string | null;
  /** Pick a different thread, or clear selection with null. */
  selectThread: (threadId: string | null) => void;
};

/**
 * Stand-alone hook used by tests and by hosts that keep thread
 * selection in local component state instead of the router.
 */
export function useThreadSelection(initial: string | null = null): ThreadSelection {
  const [threadId, setThreadId] = useState<string | null>(initial);

  const selectThread = useCallback((next: string | null) => {
    setThreadId(next);
  }, []);

  return { threadId, selectThread };
}
